import { inject } from '@angular/core';
import { CanActivateFn } from '@angular/router';
import { KeycloakService } from 'keycloak-angular';

/**
 * Guard síncrono: não chama updateToken nem isLoggedIn() assíncrono (evita rede em navegação / Back).
 */
export const authGuard: CanActivateFn = (_route, state) => {
  const keycloak = inject(KeycloakService);
  const kc = keycloak.getKeycloakInstance();

  if (!kc.authenticated) {
    void keycloak.login({
      redirectUri: window.location.origin + state.url,
    });
    return false;
  }

  return true;
};
